function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-99.419 -110.938)",
  id: "layer1",
  stroke: "#f9f9f9",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M139.956 114.878c-6.13-1.826-12.535-3.92-19.006-3.025-2.99 1.119-6.302 2.014-8.706 4.231-2.991 1.386-5.714 3.428-7.488 6.258-2.962 3.987-3.681 9.092-4.479 13.864-.573 2.786.702 5.453.61 8.234.058.957.55 2.962 1.049 3.61 1.013 2.597 2.294 4.7 3.94 6.967 3.172 3.645 6.03 7.774 10.188 10.374 4.846 2.16 10.388 1.433 15.399.256 2.338-.554 4.743.009 7.053-.876 3.642-1.373 7.419-2.91 10.308-5.578 1.973-2.762 4.21-5.615 4.832-9.025.202-4.59.937-9.227.284-13.83-.242-3.04-1.5-5.805-2.657-8.551-1.53-2.145-1.773-4.923-3.246-7.085-.537-1.553-1.306-3.103-2.253-3.86-1.643-1.387-3.771-1.594-5.828-1.964z",
  id: "path3104",
  fill: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.832 148.876c.063.338.306 9.07.568 9.274.59.63 2.997 1.047 3.854 1.15.224-.068.26-.449.346-.666.18-.734.098-9.964.176-10.71.02-.355-.242-.671-.58-.759-1.763-.299-4.76-.56-4.364 1.711z",
  id: "path3140",
  fill: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M118.599 126.224c-.908-.154-1.824-.272-2.618.321-.805.242-1.72.509-2.156 1.302-.59 1.074-1.418 2.002-1.987 3.084a6.262 6.262 0 01-.734 1.811c-.515.856-.522 1.945-.06 2.825a12.97 12.97 0 001.85 3.555c.42.714.882 1.454 1.687 1.777 1.747.834 3.775 1.13 5.683.78 1.66-.308 2.842-1.78 3.263-3.35.144-.717.606-1.19.931-1.812.531-1.133.807-2.426.601-3.672 0 0-.425-1.119-.7-1.539-.296-.68-.35-1.445-.686-2.108-.573-.48-.972-.91-1.652-1.37-.462-.523-2.447-1.519-3.422-1.604z",
  id: "path3155",
  fill: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "path3158",
  d: "M137.936 126.457c-.742-.126-1.49-.222-2.14.263-.658.197-1.406.415-1.762 1.064-.482.878-1.16 1.636-1.625 2.52a5.12 5.12 0 01-.6 1.482c-.42.7-.427 1.59-.05 2.309.35 1.042.863 2.02 1.513 2.906.344.583.721 1.188 1.38 1.453 1.428.681 3.086.923 4.646.638 1.357-.252 2.323-1.456 2.667-2.739.118-.586.496-.973.761-1.482.434-.926.66-1.983.492-3.001 0 0-.348-.915-.573-1.258-.242-.557-.287-1.182-.56-1.724-.47-.392-.795-.743-1.351-1.12-.378-.427-2-1.241-2.798-1.31z",
  fill: "none",
  strokeOpacity: 1
}), /*#__PURE__*/React.createElement("circle", {
  r: 1.51,
  cy: 134.267,
  cx: 135.945,
  id: "path3160",
  fill: "#f9f9f9",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "circle3162",
  cx: 116.275,
  cy: 132.427,
  r: 1.51,
  fill: "#f9f9f9",
  fillOpacity: 1
}));

var SvgLoader = function SvgLoader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2537",
    viewBox: "0 0 55.489 56.543",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader.06ce4f3b.svg";
export { ForwardRef as ReactComponent };